import { Component, Input, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { LoaderService } from '../../../services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnDestroy {

  @Input() isStructureComponent: boolean;
  @Input() habilitationType: string;
  subscription: Subscription;
  isLoading: boolean;

  constructor(private readonly loaderService: LoaderService) {
    this.subscription = this.loaderService.isLoading.subscribe(v => {
      this.isLoading = v;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
